import { Component, useState } from "react";
import { LabelContainer } from "../assets/style";
import { Box, FormControl, MenuItem, Select, SelectChangeEvent, SelectProps } from "@mui/material";
import FormLongLabel from "./FormLongLabel";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface HookFormDropDownListProps<T extends FieldValues> {
    title?: any
    sameRowTitle?: any
    items: { id: any, name: string }[]
    name: Path<T>
    control: Control<T, any>
}

export default function HookFormDropDownList<T extends FieldValues>(props: HookFormDropDownListProps<T>) {
    const { title, sameRowTitle, items, name, control } = props
    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "100px",
        maxWidth: "600px",
    };
    const inputStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        height: "32px",
        // maxWidth: "250px",
        width: "50%",

    };

    return (
        <div >
            {title && <FormLongLabel title={title} />}
            <Box sx={containerStyle}>
                {
                    sameRowTitle && <LabelContainer style={{ marginLeft: "28px" }}>
                        {sameRowTitle + ": "}
                    </LabelContainer>
                }
                <FormControl sx={inputStyle}>
                    <Controller
                        name={name}
                        control={control}
                        render={({ field: { onChange, onBlur, value } }) => (
                            <Select
                                onChange={(event) => {
                                    console.log(event)
                                    onChange(event)
                                }}
                                onBlur={onBlur}
                                value={value ?? ""}
                                style={{ marginBottom: "20px", backgroundColor: "white", height: "32px" }}
                            >
                                {items?.map((item, index) =>
                                    <MenuItem selected={item.id == value} key={index} value={item.id}>
                                        {item.name}
                                    </MenuItem>)}
                            </Select>
                        )}
                    />
                </FormControl>
            </Box>
        </div>
    );
}
